module.exports = __webpack_public_path__ + "img/rtlogo.b4d9ec11.png";